import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { TableName } from "../constants/tableName";

export class MaintenanceController {
  static TABLE_NAME = TableName.MAINTENANCE;

  static get = ({ id, resolve, reject }) => {
    let errorMessage =
      "Unable to get all the maintenance details.\nPlease contact administrator for assistance.";
    getDoc(doc(db, this.TABLE_NAME, id))
      .then((data) => {
        console.debug(data);
        resolve(data);
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static errorHandling = ({ errorMessage, error }) => {
    switch (error.code) {
      case "permission-denied":
        errorMessage = "You are not authorised for this action.";
        break;
      default:
        break;
    }
    console.debug(error.message);
    return errorMessage;
  };
}
